<template>
  <DrupalLink
    v-if="url"
    :to="url"
    class="button"
    :class="index === 0 ? 'is-filled mr-3' : ''"
  >
    <slot :url="url" :title="title">
      {{ title }}
    </slot>
  </DrupalLink>
</template>

<script lang="ts" setup>
import type {
  FieldItemTypeLinkDescriptionFragment,
  FieldItemTypeLinkDescriptionEntityFragment,
} from '#graphql-operations'

const props = defineProps<{
  linkTitle?: FieldItemTypeLinkDescriptionFragment['linkTitle']
  uri?: FieldItemTypeLinkDescriptionFragment['uri']
  index?: number
}>()

const entity = computed<FieldItemTypeLinkDescriptionEntityFragment | undefined>(
  () => {
    if (props.uri && 'entity' in props.uri) {
      return props.uri.entity
    }
    return undefined
  },
)

const title = computed(() => {
  // Use provided link title.
  if (props.linkTitle) {
    return props.linkTitle
  }

  // Fallback to shwowing the URL. Better than nothing.
  return url.value
})

const index = computed(() => {
  return props.index
})

const url = computed(() => {
  if (entity.value && entity.value?.__typename === 'MediaDocument') {
    return entity.value?.mediaFileUrl?.path
  }

  return props.uri?.path
})
</script>
